import { useLayoutEffect } from 'react';
import { spring } from '@/utils/animations/commom';
import { getDomByTestId } from '@/utils/questions/dnd/dndNodes';
import { playFlip } from '@/utils/questions/dnd/playFlip';

type FlipIntoPlaceArgs = {
  testId?: string;
  from?: DOMRect;
  fadeIn?: boolean;
  onDone?: () => void;
};

export function useFlipIntoPlace({
  testId,
  from,
  fadeIn,
  onDone,
}: FlipIntoPlaceArgs) {
  useLayoutEffect(() => {
    if (!from || !testId) return;

    const node = getDomByTestId(testId);
    if (!node) {
      onDone?.();
      return;
    }

    const { left, top } = node.getBoundingClientRect();
    const dx = from.left - left;
    const dy = from.top - top;
    if (!dx && !dy && !fadeIn) {
      onDone?.();
      return;
    }

    return playFlip({
      node,
      keyframes: fadeIn
        ? { x: [dx, 0], y: [dy, 0], opacity: [0.2, 1] }
        : { x: [dx, 0], y: [dy, 0] },
      options: spring,
      onSettle: settled => {
        settled.style.transform = '';
        settled.style.opacity = '';
      },
      onDone,
    });
  }, [from, testId, fadeIn, onDone]);
}
